export function CheckTransparentCircleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M10.0492 5.99922C10.0492 8.23597 8.23597 10.0492 5.99922 10.0492C3.76247 10.0492 1.94922 8.23597 1.94922 5.99922C1.94922 3.76247 3.76247 1.94922 5.99922 1.94922C8.23597 1.94922 10.0492 3.76247 10.0492 5.99922ZM8.75381 5.75381C9.28102 5.22661 9.28102 4.37183 8.75381 3.84462C8.2266 3.31742 7.37183 3.31742 6.84462 3.84463L5.39922 5.29003L5.15381 5.04462C4.6266 4.51742 3.77183 4.51742 3.24462 5.04463C2.71742 5.57183 2.71742 6.4266 3.24462 6.95381L4.44462 8.15381C4.97183 8.68102 5.8266 8.68102 6.35381 8.15381L8.75381 5.75381Z'
        fill='white'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    </svg>
  )
}
